/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const BEFORE_LOGIN_NAV = [
    {
        type: "link",
        link: "/#about",
        name: "About Us",
    },
    {
        type: "dropdown",
        id: "categories",
        name: "Categories",
        items: [
            {
                type: "link",
                link: "#diageo-india",
                name: "DiageoIndia",
                eventKey: "diageo-india",
            },
            {
                type: "link",
                link: "#rc-rcb",
                name: "RC-RCB",
                eventKey: "rc-rcb",
            },
            {
                type: "link",
                link: "#the-true-bonds-of-yaari",
                name: "THE TRUE BONDS OF YAARI",
                eventKey: "the-true-bonds-of-yaari",
            },
            {
                type: "link",
                link: "#johnnie-walker-story",
                name: "Johnnie Walker Story",
                eventKey: "johnnie-walker-story",
            },
            {
                type: "link",
                link: "#epitome-reserve",
                name: "Epitome Reserve",
                eventKey: "epitome-reserve",
            },
        ],
    },
    {
        type: "link",
        link: "/#store",
        name: "Download Wallet",
    },
    {
        type: "link",
        link: "/#contact",
        name: "Contact",
    },
    {
        type: "avatar",
        link: "/my-profile",
        avatar: "https://dev-dc.vlinder.io/imgsrv/imgbb/kSw95Qb/profile-icon-white.png/:/rs=w:50",
    },
    {
        type: "avatar",
        link: "/my-wallet",
        avatar: "https://dev-dc.vlinder.io/imgsrv/imgbb/NVCF8f1/wallet-white.png/:/rs=w:50",
    },
];

export const AFTER_LOGIN_NAV = [
    {
        type: "link",
        link: "/#about",
        name: "About Us",
    },
    {
        type: "dropdown",
        id: "categories",
        name: "Categories",
        items: [
            {
                type: "link",
                link: "#diageo-india",
                name: "DiageoIndia",
                eventKey: "diageo-india",
            },
            {
                type: "link",
                link: "#rc-rcb",
                name: "RC-RCB",
                eventKey: "rc-rcb",
            },
            {
                type: "link",
                link: "#the-true-bonds-of-yaari",
                name: "THE TRUE BONDS OF YAARI",
                eventKey: "the-true-bonds-of-yaari",
            },
            {
                type: "link",
                link: "#johnnie-walker-story",
                name: "Johnnie Walker Story",
                eventKey: "johnnie-walker-story",
            },
            {
                type: "link",
                link: "#epitome-reserve",
                name: "Epitome Reserve",
                eventKey: "epitome-reserve",
            },
        ],
    },
    {
        type: "link",
        link: "/#contact",
        name: "Contact",
    },
    {
        type: "avatarDropdown",
        name: "KS",
        avatar: require("../../assets/res/images/account.png"),
        items: [
            {
                type: "link",
                link: "/my-wallet",
                name: "My Wallet",
                eventKey: "wallet",
            },
            {
                type: "link",
                link: "/my-profile",
                name: "My Profile",
                eventKey: "profile",
            },
            {
                type: "link",
                link: "/my-transactions",
                name: "My Transaction",
                eventKey: "transaction",
            },
            {
                type: "link",
                link: "/logout",
                name: "Logout",
                eventKey: "logout",
            },
        ],
    },
];

export const INNER_LOGIN_NAV = [
    {
        type: "link",
        link: "/#about",
        name: "About Us",
    },
    {
        type: "dropdown",
        id: "categories",
        name: "Categories",
        items: [
            {
                type: "link",
                link: "/collection/diageo-india",
                name: "DiageoIndia",
                eventKey: "diageo-india",
            },
            {
                type: "link",
                link: "/collection/rc-rcb",
                name: "RC-RCB",
                eventKey: "rc-rcb",
            },
            {
                type: "link",
                link: "/collection/the-true-bonds-of-yaari",
                name: "THE TRUE BONDS OF YAARI",
                eventKey: "the-true-bonds-of-yaari",
            },
            {
                type: "link",
                link: "/collection/johnnie-walker-story",
                name: "Johnnie Walker Story",
                eventKey: "johnnie-walker-story",
            },
            {
                type: "link",
                link: "/collection/epitome-reserve",
                name: "Epitome Reserve",
                eventKey: "epitome-reserve",
            },
        ],
    },
    {
        type: "link",
        link: "/#contact",
        name: "Contact",
    },
    {
        type: "avatarDropdown",
        name: "Mahendra C",
        avatar: require("../../assets/res/images/account.png"),
        items: [
            {
                type: "link",
                link: "/my-wallet",
                name: "My Wallet",
                eventKey: "wallet",
            },
            {
                type: "link",
                link: "/my-profile",
                name: "My Profile",
                eventKey: "profile",
            },
            {
                type: "link",
                link: "/my-transactions",
                name: "My Transaction",
                eventKey: "transaction",
            },
            {
                type: "link",
                link: "/logout",
                name: "Logout",
                eventKey: "logout",
            },
        ],
    },
];

export const INNER_LOGOUT_NAV = [
    {
        type: "link",
        link: "/#about",
        name: "About Us",
    },
    {
        type: "dropdown",
        id: "categories",
        name: "Categories",
        items: [
            {
                type: "link",
                link: "/collection/diageo-india",
                name: "DiageoIndia",
                eventKey: "diageo-india",
            },
            {
                type: "link",
                link: "/collection/rc-rcb",
                name: "RC-RCB",
                eventKey: "rc-rcb",
            },
            {
                type: "link",
                link: "/collection/the-true-bonds-of-yaari",
                name: "THE TRUE BONDS OF YAARI",
                eventKey: "the-true-bonds-of-yaari",
            },
            {
                type: "link",
                link: "/collection/johnnie-walker-story",
                name: "Johnnie Walker Story",
                eventKey: "johnnie-walker-story",
            },
            {
                type: "link",
                link: "/collection/epitome-reserve",
                name: "Epitome Reserve",
                eventKey: "epitome-reserve",
            },
        ],
    },
    {
        type: "link",
        link: "/#contact",
        name: "Contact",
    },
    {
        type: "avatar",
        link: "/my-profile",
        avatar: "https://dev-dc.vlinder.io/imgsrv/imgbb/kSw95Qb/profile-icon-white.png/:/rs=w:50",
    },
    {
        type: "avatar",
        link: "/my-wallet",
        avatar: "https://dev-dc.vlinder.io/imgsrv/imgbb/NVCF8f1/wallet-white.png/:/rs=w:50",
    },
];
